export const SET_USER = 'SET_USER'



// WEBPACK FOOTER //
// ./api/user/actionTypes.js